import type { TPlayer } from 'video.js'
import type { SettingsMenuContainer } from '../settings-menu-container'

import { register } from '|>/shared/vjs'
import { BaseComponent } from '../../base'
import { SubtitlesTrackButton } from './subtitles-track-button'

/**
 * Settings subtitles menu with available subtitles tracks
 */
@register
export class SettingsSubtitlesLanguageMenu extends BaseComponent {
  declare options_: any
  declare container: SettingsMenuContainer | undefined

  trackButton_: SubtitlesTrackButton
  menu: SubtitlesTrackButton['menu'] | undefined

  constructor(player: TPlayer, options: any) {
    super(player, options)

    this.trackButton_ = new SubtitlesTrackButton(player, {
      title: this.localize(options.title),
      getContainer: () => this.container,
    })

    this.handleNewTracks = this.handleNewTracks.bind(this)

    const textTracks = this.player_.textTracks()
    // Handle case where audio menu opened before tracks are fully loaded by player
    textTracks?.addEventListener('addtrack', this.handleNewTracks)

    this.on('dispose', () => {
      textTracks?.removeEventListener('addtrack', this.handleNewTracks)
    })
  }

  override contentEl() {
    // return _parent_'s container element, so any child, added to this component,
    // will be added to the parent container's element instead
    if (!this.container) throw new Error('container is not set')
    return this.container.contentEl()
  }

  override handleLanguagechange() {
    this.trackButton_.title(this.localize(this.options_.title))
  }

  update() {
    this.trackButton_.update()

    if (this.menu) {
      this.menu.dispose()
      this.removeChild(this.menu)
    }

    this.menu = this.trackButton_.menu
    this.addChild(this.menu)
  }

  handleNewTracks() {
    this.update()
  }

  activate() {
    this.update()

    if (this.menu?.el_) this.menu.addClass('vjs-x-active')
  }

  deactivate() {
    if (this.menu?.el_) this.menu.removeClass('vjs-x-active')
  }
}

SettingsSubtitlesLanguageMenu.options = {
  createEl: false, // this component is opaque, it has no element
}
